









import Vue from "vue";

export default Vue.extend({
  name: "TooltipIconBtn",
  props: ["tip", "icon", "bottom", "top", "left", "right"],
});
